export const DEFAULT_SKELETON_COUNT = 16;
export const SKELETON_ASPECT_RATIO = "0.75 / 1";
export const SKELETON_BORDER_RADIUS = "0.75rem";
